// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*************************** Common Table Section Start *******************/

/* ================== BASE CONTAINER ================== */

.tableContainer {
    border: 1px solid var(--primary-border);
    border-radius: 4px;
    margin-bottom: 30px;
    color: var(--common-text-color);
    background-color: var(--primary-white-bg);
}

.tableWrapper {
    position: relative;
    overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
    direction: ltr;
    /* Safari RTL scroll fix */
    background-color: var(--primary-white-bg);
}

.rtl .tableWrapper {
    direction: ltr;
}

/* ================== TABLE ================== */

.tableContainer a {
    color: var(--common-link-color);
}

.tableContainer .tableBox {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    background-color: var(--primary-white-bg);
}

.rtl .tableContainer .tableBox {
    direction: rtl;
}

.tableContainer .tableBox caption {
    font-size: 18px;
    margin: .5em 0 .75em;
}

.tableContainer .tableBox thead tr {
    background-color: var(--common-gray-bg-color);
}

.tableContainer .tableBox tbody tr,
.tableContainer .tableBox tbody tr td {
    background-color: var(--primary-white-bg);
}

.tableContainer th,
.tableContainer td {
    padding: 12px;
    min-width: 250px;
    font-size: 16px;
    line-height: 22px;
    white-space: normal;
}

.tableContainer th {
    font-weight: 600;
    background-color: var(--common-gray-bg-color);
}

.tableContainer td {
    border-top: 1px solid var(--primary-border);
}

/* ================== STICKY COLUMNS ================== */

.tableContainer td:first-child,
.tableContainer th:first-child,
.tableContainer td:nth-child(2),
.tableContainer th:nth-child(2) {
    position: sticky;
    top: 0;
    z-index: 3;

    /* Safari repaint fixes */
    background-clip: padding-box;
    background-attachment: local;
    transform: translateZ(0);
    backface-visibility: visible;
}

/* LTR */

.tableContainer td:first-child,
.tableContainer th:first-child {
    left: 0;
    min-width: 120px;
}

.tableContainer td:nth-child(2),
.tableContainer th:nth-child(2) {
    left: 120px;
    min-width: 300px;
}

/* RTL */

.rtl .tableContainer td:first-child,
.rtl .tableContainer th:first-child {
    left: unset !important;
    right: 0;
}

.rtl .tableContainer td:nth-child(2),
.rtl .tableContainer th:nth-child(2) {
    left: unset !important;
    right: 120px;
}

/* Divider shadow */

.tableContainer td:nth-child(2)::after {
    content: '';
    position: absolute;
    inset: 0;
    box-shadow: 4px 0px 2px #B2BEC41A;
    pointer-events: none;
}

.rtl .tableContainer td:nth-child(2)::after {
    box-shadow: -4px 0px 2px #B2BEC41A;
}

/* ================== NO DATA ================== */

.noRecordsText {
    text-align: center;
    font-size: 18px;
    padding: 80px 18px;
}

.tableNoDataContainer td:first-child,
.tableNoDataContainer th:first-child,
.tableNoDataContainer td:nth-child(2),
.tableNoDataContainer th:nth-child(2) {
    position: static;
}

/* ================== PAYOUT TABLE ================== */

.tableContainer.payoutListTable {
    margin-bottom: 0;
}

.tableContainer.payoutListTable td:first-child,
.tableContainer.payoutListTable th:first-child {
    left: 0;
    min-width: 200px;
}

.tableContainer.payoutListTable td:nth-child(2),
.tableContainer.payoutListTable th:nth-child(2) {
    left: 200px;
    min-width: 220px;
}

.rtl .tableContainer.payoutListTable td:first-child,
.rtl .tableContainer.payoutListTable th:first-child {
    left: unset;
    right: 0;
}

.rtl .tableContainer.payoutListTable td:nth-child(2),
.rtl .tableContainer.payoutListTable th:nth-child(2) {
    left: unset;
    right: 200px;
}

.purchaseHistoryTable {
    margin-top: 18px;
}

/* ================== SAFARI ONLY ================== */

@supports (-webkit-touch-callout: none) {

    .rtl .tableContainer td:first-child,
    .rtl .tableContainer th:first-child,
    .rtl .tableContainer td:nth-child(2),
    .rtl .tableContainer th:nth-child(2) {
        transform: translateZ(0);
        backface-visibility: visible;
    }
}

/* ================== DESKTOP SPACING ================== */

@media (min-width: 992px) {

    .tableContainer th:first-child,
    .tableContainer td:first-child,
    .tableContainer th:nth-child(3),
    .tableContainer td:nth-child(3) {
        padding-left: 40px;
    }

    .rtl .tableContainer th:first-child,
    .rtl .tableContainer td:first-child,
    .rtl .tableContainer th:nth-child(3),
    .rtl .tableContainer td:nth-child(3) {
        padding-right: 40px;
        padding-left: 12px;
    }

    .tableNoDataContainer th:first-child,
    .tableNoDataContainer td:first-child,
    .tableNoDataContainer td:nth-child(3),
    .tableNoDataContainer th:nth-child(3),
    .purchaseHistoryTable th:first-child,
    .purchaseHistoryTable td:first-child {
        padding-left: 18px !important;
    }

    .rtl .tableNoDataContainer th:first-child,
    .rtl .tableNoDataContainer td:first-child,
    .rtl .tableNoDataContainer td:nth-child(3),
    .rtl .tableNoDataContainer th:nth-child(3),
    .rtl .purchaseHistoryTable th:first-child,
    .rtl .purchaseHistoryTable td:first-child {
        padding-right: 18px !important;
        padding-left: 12px !important;
    }
}

/* ================== MOBILE STACK ================== */

@media (max-width: 991px) {

    .tableContainer {
        border: none;
    }

    .tableWrapper {
        overflow-x: visible;
    }

    .tableContainer .tableBox thead {
        position: absolute;
        clip: rect(0 0 0 0);
        height: 1px;
        width: 1px;
        overflow: hidden;
    }

    .tableContainer .tableBox tr {
        display: block;
        border: 1px solid var(--primary-border);
        border-radius: 4px;
        margin-bottom: 24px;
    }

    .tableContainer .tableBox tr:last-child {
        margin-bottom: 0;
    }

    .tableContainer .tableBox td {
        position: static;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
        min-width: 0 !important;
        z-index: auto;
    }

    .tableContainer .tableBox td::before {
        content: attr(data-label);
        font-weight: 600;
    }

    .tableContainer .tableBox td:first-child {
        border-top: none;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }

    .tableContainer .tableBox td:last-child {
        border-bottom: none;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .tableContainer td:nth-child(2)::after {
        display: none;
    }

    .tableNoDataContainer .tableBox td {
        grid-template-columns: 100%;
    }

    .tableNoDataContainer .tableBox td::before {
        display: none;
    }

    .rtl .tableContainer td:first-child,
    .rtl .tableContainer th:first-child,
    .rtl .tableContainer td:nth-child(2),
    .rtl .tableContainer th:nth-child(2) {
        position: static !important;
        min-width: 0 !important;
    }
}

@media (max-width: 480px) {
    .tableContainer .tableBox tr {
        margin-bottom: 18px;
    }

    .tableContainer .tableBox td {
        grid-template-columns: 100%;
    }
}

/*************************** Common Table Section End *******************/`, "",{"version":3,"sources":["webpack://./src/styles/commonTable.css"],"names":[],"mappings":"AAAA,2EAA2E;;AAE3E,yDAAyD;;AAEzD;IACI,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,cAAc;IACd,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,cAAc;AAClB;;AAEA,gDAAgD;;AAEhD;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,2CAA2C;AAC/C;;AAEA,yDAAyD;;AAEzD;;;;IAII,gBAAgB;IAChB,MAAM;IACN,UAAU;;IAEV,yBAAyB;IACzB,4BAA4B;IAC5B,4BAA4B;IAC5B,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA,QAAQ;;AAER;;IAEI,OAAO;IACP,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,gBAAgB;AACpB;;AAEA,QAAQ;;AAER;;IAEI,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;;IAEI,sBAAsB;IACtB,YAAY;AAChB;;AAEA,mBAAmB;;AAEnB;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,iCAAiC;IACjC,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;AACtC;;AAEA,kDAAkD;;AAElD;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;;IAII,gBAAgB;AACpB;;AAEA,uDAAuD;;AAEvD;IACI,gBAAgB;AACpB;;AAEA;;IAEI,OAAO;IACP,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,QAAQ;AACZ;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,sDAAsD;;AAEtD;;IAEI;;;;QAII,wBAAwB;QACxB,4BAA4B;IAChC;AACJ;;AAEA,0DAA0D;;AAE1D;;IAEI;;;;QAII,kBAAkB;IACtB;;IAEA;;;;QAII,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;;;;;;QAMI,6BAA6B;IACjC;;IAEA;;;;;;QAMI,8BAA8B;QAC9B,6BAA6B;IACjC;AACJ;;AAEA,uDAAuD;;AAEvD;;IAEI;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,WAAW;QACX,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,uCAAuC;QACvC,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,qCAAqC;QACrC,SAAS;QACT,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,2BAA2B;QAC3B,4BAA4B;IAChC;;IAEA;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,+BAA+B;IACnC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;;IAEA;;;;QAII,2BAA2B;QAC3B,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA,yEAAyE","sourcesContent":["/*************************** Common Table Section Start *******************/\n\n/* ================== BASE CONTAINER ================== */\n\n.tableContainer {\n    border: 1px solid var(--primary-border);\n    border-radius: 4px;\n    margin-bottom: 30px;\n    color: var(--common-text-color);\n    background-color: var(--primary-white-bg);\n}\n\n.tableWrapper {\n    position: relative;\n    overflow-x: auto;\n    overflow-y: visible;\n    -webkit-overflow-scrolling: touch;\n    direction: ltr;\n    /* Safari RTL scroll fix */\n    background-color: var(--primary-white-bg);\n}\n\n.rtl .tableWrapper {\n    direction: ltr;\n}\n\n/* ================== TABLE ================== */\n\n.tableContainer a {\n    color: var(--common-link-color);\n}\n\n.tableContainer .tableBox {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    background-color: var(--primary-white-bg);\n}\n\n.rtl .tableContainer .tableBox {\n    direction: rtl;\n}\n\n.tableContainer .tableBox caption {\n    font-size: 18px;\n    margin: .5em 0 .75em;\n}\n\n.tableContainer .tableBox thead tr {\n    background-color: var(--common-gray-bg-color);\n}\n\n.tableContainer .tableBox tbody tr,\n.tableContainer .tableBox tbody tr td {\n    background-color: var(--primary-white-bg);\n}\n\n.tableContainer th,\n.tableContainer td {\n    padding: 12px;\n    min-width: 250px;\n    font-size: 16px;\n    line-height: 22px;\n    white-space: normal;\n}\n\n.tableContainer th {\n    font-weight: 600;\n    background-color: var(--common-gray-bg-color);\n}\n\n.tableContainer td {\n    border-top: 1px solid var(--primary-border);\n}\n\n/* ================== STICKY COLUMNS ================== */\n\n.tableContainer td:first-child,\n.tableContainer th:first-child,\n.tableContainer td:nth-child(2),\n.tableContainer th:nth-child(2) {\n    position: sticky;\n    top: 0;\n    z-index: 3;\n\n    /* Safari repaint fixes */\n    background-clip: padding-box;\n    background-attachment: local;\n    transform: translateZ(0);\n    backface-visibility: visible;\n}\n\n/* LTR */\n\n.tableContainer td:first-child,\n.tableContainer th:first-child {\n    left: 0;\n    min-width: 120px;\n}\n\n.tableContainer td:nth-child(2),\n.tableContainer th:nth-child(2) {\n    left: 120px;\n    min-width: 300px;\n}\n\n/* RTL */\n\n.rtl .tableContainer td:first-child,\n.rtl .tableContainer th:first-child {\n    left: unset !important;\n    right: 0;\n}\n\n.rtl .tableContainer td:nth-child(2),\n.rtl .tableContainer th:nth-child(2) {\n    left: unset !important;\n    right: 120px;\n}\n\n/* Divider shadow */\n\n.tableContainer td:nth-child(2)::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    box-shadow: 4px 0px 2px #B2BEC41A;\n    pointer-events: none;\n}\n\n.rtl .tableContainer td:nth-child(2)::after {\n    box-shadow: -4px 0px 2px #B2BEC41A;\n}\n\n/* ================== NO DATA ================== */\n\n.noRecordsText {\n    text-align: center;\n    font-size: 18px;\n    padding: 80px 18px;\n}\n\n.tableNoDataContainer td:first-child,\n.tableNoDataContainer th:first-child,\n.tableNoDataContainer td:nth-child(2),\n.tableNoDataContainer th:nth-child(2) {\n    position: static;\n}\n\n/* ================== PAYOUT TABLE ================== */\n\n.tableContainer.payoutListTable {\n    margin-bottom: 0;\n}\n\n.tableContainer.payoutListTable td:first-child,\n.tableContainer.payoutListTable th:first-child {\n    left: 0;\n    min-width: 200px;\n}\n\n.tableContainer.payoutListTable td:nth-child(2),\n.tableContainer.payoutListTable th:nth-child(2) {\n    left: 200px;\n    min-width: 220px;\n}\n\n.rtl .tableContainer.payoutListTable td:first-child,\n.rtl .tableContainer.payoutListTable th:first-child {\n    left: unset;\n    right: 0;\n}\n\n.rtl .tableContainer.payoutListTable td:nth-child(2),\n.rtl .tableContainer.payoutListTable th:nth-child(2) {\n    left: unset;\n    right: 200px;\n}\n\n.purchaseHistoryTable {\n    margin-top: 18px;\n}\n\n/* ================== SAFARI ONLY ================== */\n\n@supports (-webkit-touch-callout: none) {\n\n    .rtl .tableContainer td:first-child,\n    .rtl .tableContainer th:first-child,\n    .rtl .tableContainer td:nth-child(2),\n    .rtl .tableContainer th:nth-child(2) {\n        transform: translateZ(0);\n        backface-visibility: visible;\n    }\n}\n\n/* ================== DESKTOP SPACING ================== */\n\n@media (min-width: 992px) {\n\n    .tableContainer th:first-child,\n    .tableContainer td:first-child,\n    .tableContainer th:nth-child(3),\n    .tableContainer td:nth-child(3) {\n        padding-left: 40px;\n    }\n\n    .rtl .tableContainer th:first-child,\n    .rtl .tableContainer td:first-child,\n    .rtl .tableContainer th:nth-child(3),\n    .rtl .tableContainer td:nth-child(3) {\n        padding-right: 40px;\n        padding-left: 12px;\n    }\n\n    .tableNoDataContainer th:first-child,\n    .tableNoDataContainer td:first-child,\n    .tableNoDataContainer td:nth-child(3),\n    .tableNoDataContainer th:nth-child(3),\n    .purchaseHistoryTable th:first-child,\n    .purchaseHistoryTable td:first-child {\n        padding-left: 18px !important;\n    }\n\n    .rtl .tableNoDataContainer th:first-child,\n    .rtl .tableNoDataContainer td:first-child,\n    .rtl .tableNoDataContainer td:nth-child(3),\n    .rtl .tableNoDataContainer th:nth-child(3),\n    .rtl .purchaseHistoryTable th:first-child,\n    .rtl .purchaseHistoryTable td:first-child {\n        padding-right: 18px !important;\n        padding-left: 12px !important;\n    }\n}\n\n/* ================== MOBILE STACK ================== */\n\n@media (max-width: 991px) {\n\n    .tableContainer {\n        border: none;\n    }\n\n    .tableWrapper {\n        overflow-x: visible;\n    }\n\n    .tableContainer .tableBox thead {\n        position: absolute;\n        clip: rect(0 0 0 0);\n        height: 1px;\n        width: 1px;\n        overflow: hidden;\n    }\n\n    .tableContainer .tableBox tr {\n        display: block;\n        border: 1px solid var(--primary-border);\n        border-radius: 4px;\n        margin-bottom: 24px;\n    }\n\n    .tableContainer .tableBox tr:last-child {\n        margin-bottom: 0;\n    }\n\n    .tableContainer .tableBox td {\n        position: static;\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        gap: 12px;\n        min-width: 0 !important;\n        z-index: auto;\n    }\n\n    .tableContainer .tableBox td::before {\n        content: attr(data-label);\n        font-weight: 600;\n    }\n\n    .tableContainer .tableBox td:first-child {\n        border-top: none;\n        border-top-left-radius: 4px;\n        border-top-right-radius: 4px;\n    }\n\n    .tableContainer .tableBox td:last-child {\n        border-bottom: none;\n        border-bottom-left-radius: 4px;\n        border-bottom-right-radius: 4px;\n    }\n\n    .tableContainer td:nth-child(2)::after {\n        display: none;\n    }\n\n    .tableNoDataContainer .tableBox td {\n        grid-template-columns: 100%;\n    }\n\n    .tableNoDataContainer .tableBox td::before {\n        display: none;\n    }\n\n    .rtl .tableContainer td:first-child,\n    .rtl .tableContainer th:first-child,\n    .rtl .tableContainer td:nth-child(2),\n    .rtl .tableContainer th:nth-child(2) {\n        position: static !important;\n        min-width: 0 !important;\n    }\n}\n\n@media (max-width: 480px) {\n    .tableContainer .tableBox tr {\n        margin-bottom: 18px;\n    }\n\n    .tableContainer .tableBox td {\n        grid-template-columns: 100%;\n    }\n}\n\n/*************************** Common Table Section End *******************/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
